import { fork } from 'redux-saga/effects';
import type { ForkEffect } from 'redux-saga/effects';

import { signInSaga } from 'state/signIn';
import { signUpStepsSaga } from 'state/signUpSteps';
import { countryCodesSaga } from 'state/countryCodes';

export default function* rootSaga(): Generator<
  ForkEffect<void>,
  void,
  unknown
> {
  yield fork(signInSaga);
  yield fork(signUpStepsSaga);
  yield fork(countryCodesSaga);
}
